<mat-expansion-panel
    [expanded]="index == opened && !itemForm.disabled"
    (opened)="opened = index"
    (closed)="opened === index && (opened = -1)"
    [disabled]="itemForm.disabled || (textMaterialHeader?.editMode | async)"
    #expansionPanel
>
    <mat-expansion-panel-header
        class="on-hover-mat-item"
        fxLayoutGap="10px"
        fxLayout="row"
        fxLayoutAlign="start center"
    >
        <mat-checkbox
            [disabled]="itemForm.disabled"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(index) : null"
            [checked]="selection.isSelected(index)"
        >
        </mat-checkbox>
        <app-material-manager-text-item-header
            #textMaterialHeader
            [ngClass]="{
                'panel-expanded': expansionPanel.expanded,
                'in-edit-mode': textMaterialHeader.editMode.value
            }"
            [expanded]="expansionPanel.expanded"
            [fxLayout.lt-md]="expansionPanel.expanded ? 'column' : 'row'"
            [item]="itemForm | cast"
            [resource]="resource"
            [index]="index"
            [disabled]="itemForm.disabled"
            (onDelete)="deleteItem($event)"
            (onCopy)="copyItem({ title: itemForm.value.title, name: itemForm.value.name })"
            (onTranslate)="translateItem({ language_id: $event, indices: [index] })"
            (onRegenerate)="regenerateItem($event)"
            (onDuplicate)="duplicateItem($event)"
            (onDisableSorting)="onDisableSorting.emit($event)"
            (onSplitText)="expansionPanel.open(); splitText($event.useAi, $event.blocksCount, $event.index)"
        ></app-material-manager-text-item-header>
        <ng-content *ngIf="!expansionPanel.expanded"></ng-content>
    </mat-expansion-panel-header>

    <ng-container *ngIf="splitMode.value">
        <div fxLayout="column" fxLayoutGap="10px" class="w-100">
            <div class="w-100 splitters-wrapper" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
                <mat-icon
                    matTooltip="Mark text you want to split into a new block. When done mark with the Split button. Repeat the process to the next text block until you are done. A copy of the original full text block will be saved for a backup."
                    i18n-matTooltip
                    >help_outline</mat-icon
                >
                <button
                    mat-button
                    [disabled]="!currentSelectedText"
                    class="split"
                    (click)="generatedBlocks = generatedBlocks + 1; onSplit(editableDiv)"
                >
                    <span>Split</span>
                    <span *ngIf="generatedBlocks > 0">({{ generatedBlocks }})</span>
                </button>
                <button mat-button class="done" (click)="onDoneSplitting()" i18n>Done</button>
            </div>
            <div
                #editableDiv
                contenteditable="true"
                class="editable"
                (mouseup)="onTextSelection(editableDiv)"
                [innerHTML]="itemForm.value.name"
            ></div>
        </div>
    </ng-container>
    <ng-container *ngIf="!splitMode.value">
        <app-text-editor
            *ngIf="active"
            class="text-mat-editor"
            fxFlex="1 1 100%"
            title="Material Text"
            i18n-title
            [showTemplates]="false"
            [formControl]="itemForm.get('name') | cast"
        ></app-text-editor>
    </ng-container>
</mat-expansion-panel>
